import React, { useRef } from "react";
import styled from "styled-components";
import EmployeeAvatar from "../../../../../../../global/avatars/EmployeeAvatar";
import { Avatar } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useHandleKeyUp } from "../../../../../../../utils/hooks";
import Popper from "../../../../../../../global/popper/Popper";
import { getProfileImageUrl } from "../../../../../../../utils/profile";

const EmployeeCardContainer = styled.div`
  position: relative;
`;

const EmployeeCardContainerExpanded = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.grays4};
  border-radius: ${(props) => props.theme.borderRadius.small};
  box-shadow: 0 0 3px 0 ${(props) => props.theme.colors.grays4};
  padding: 10px;
  margin-top: 5px;
`;

const useStyles = makeStyles({
  circular: {
    border: "2px solid transparent",

    "&:hover": {
      border: "2px solid darkgrey",
    },
  },
});

type Props = {
  id: string;
  imgLink?: string | null;
  firstName?: string;
  lastName?: string;
  position?: string | null;
};

const EmployeeCardCollapsed = (props: Props): JSX.Element => {
  const classes = useStyles();
  const [state, setState] = useHandleKeyUp();
  const avatarAnchor = useRef(null);

  const imageUrl = getProfileImageUrl(props.imgLink);

  return (
    <EmployeeCardContainer>
      <Avatar
        ref={avatarAnchor}
        id={props.id}
        style={{ marginLeft: 0 }}
        classes={classes}
        src={imageUrl}
        alt={props.firstName}
        onClick={(event) => {
          event.stopPropagation();
          setState(!state);
        }}
      />
      <Popper
        placement="bottom-end"
        anchorEl={avatarAnchor.current}
        open={state}
      >
        <EmployeeCardContainerExpanded>
          <EmployeeAvatar
            imgLink={props.imgLink}
            firstName={props.firstName || ""}
            lastName={props.lastName || ""}
            position={props.position}
            employeeId={props.id}
            contractId={""}
            missingData={false}
          />
        </EmployeeCardContainerExpanded>
      </Popper>
    </EmployeeCardContainer>
  );
};

export default EmployeeCardCollapsed;
